export default __webpack_public_path__ + "static/media/mapCompany.0607f1a2.jpg";